import React, { Component } from "react";
import { Button, Row, Col } from "reactstrap";
class StoryItems extends Component {
  render() {
    return (
      <div className="col-lg-12 col-sm-12 col-md-12 mobiltFiltersBlock mobile-filter-stories">
        <Row>
          <Col xs="4">
            <div className="templatePara1">
              <span
                onClick={this.props.toggleCollapseClick}
                className="text-primary"
              >
                Cancel
              </span>
            </div>
          </Col>
          <Col xs="8">
            <div className="templatePara1"> Filters on Posts </div>
          </Col>
        </Row>
        <div className="mobile-filter-list">
          <div class="stories-topics mt-2">
            <Row>
              <Col sm="12">
                <div className="templatePara1"> Categories </div>
              </Col>
            </Row>
            {this.props.storyTemplates &&
            this.props.storyTemplates.length > 0 ? (
              <div className="stories-topics-list">
                {this.props.selectedTagFilterccount > 0 ? (
                  <div className="storyGroupContainer">
                    <div
                      className="storyGroups"
                      onClick={() => this.props.filterbyTagClick("all")}
                    >
                      All
                    </div>
                  </div>
                ) : (
                  <div className="storyGroupContainer">
                    <div className="storyGroupsSelected">All</div>
                  </div>
                )}
                {this.props.storyTemplates.map((tag, idx) => {
                  return (
                    <div
                      className="storyGroupContainer"
                      onClick={() => this.props.filterbyTagClick(tag)}
                      key={idx}
                    >
                      <div
                        className={
                          this.props.Tagsfilters.indexOf(tag._id) > -1
                            ? "storyGroupsSelected"
                            : "storyGroups"
                        }
                      >
                        {tag.name}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
          <div class="stories-topics mt-2">
            <Row>
              <Col sm="12">
                <div className="templatePara1"> Tags </div>
              </Col>
            </Row>
            <div className="stories-topics-list">
              {this.props.topics && this.props.topics.length > 0 ? (
                <div className="stories-topics-list">
                  {this.props.selectedCategoriesFiltercount > 0 ? (
                    <div
                      className="storyGroupContainer"
                      onClick={() => this.props.filterTopicClick("all")}
                    >
                      <div className="storyGroups">All</div>
                    </div>
                  ) : (
                    <div className="storyGroupContainer">
                      <div className="storyGroupsSelected">All</div>
                    </div>
                  )}
                  {this.props.topics.map((topic, idx) => {
                    return (
                      <div
                        className="storyGroupContainer"
                        onClick={() => this.props.filterTopicClick(topic)}
                        key={idx}
                      >
                        <div
                          className={
                            this.props.filters.indexOf(topic.code) > -1
                              ? "storyGroupsSelected"
                              : "storyGroups"
                          }
                        >
                          {topic.name}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div
          className="ipad-clear-filter"
          style={{
            marginTop: "30px",
            display: "block",
            alignItems: "center",
            fontSize: "18px",
            lineHeight: "25px",
          }}
        >
          <span
            className="mobile-clear-filter"
            style={{
              marginLeft: "20px",
              color: "#1679C4",
              fontSize: "18px",
              cursor: "pointer",
              lineHeight: "25px",
            }}
            onClick={this.props.handleClearFiltersClick}
          >
            Clear Filters
          </span>
          <span className="ipad-apply-button">
            <Button
              color="primary"
              size="lg"
              style={{ borderRadius: "0" }}
              block
              onClick={this.props.toggleCollapseClick}
            >
              Apply
            </Button>
          </span>
        </div>
      </div>
    );
  }
}
export default StoryItems;
